/**
 * @generated SignedSource<<e6ca2913b494ccde915b6ba8e1617d8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PersonBulkUpdateHolidaysGroupMutation$variables = {
  current_holidays_group_id?: number | null | undefined;
  id: ReadonlyArray<number>;
  new_holidays_group_id?: number | null | undefined;
};
export type PersonBulkUpdateHolidaysGroupMutation$data = {
  readonly updatePeopleHolidayGroup: {
    readonly account: {
      readonly holidays_groups: ReadonlyArray<{
        readonly id: number;
        readonly people_aggregate: {
          readonly aggregate: {
            readonly count: number;
          } | null | undefined;
        };
      }>;
      readonly id: number;
      readonly people: ReadonlyArray<{
        readonly holidays_group: {
          readonly id: number;
        } | null | undefined;
        readonly id: number;
      }>;
    } | null | undefined;
  };
};
export type PersonBulkUpdateHolidaysGroupMutation = {
  response: PersonBulkUpdateHolidaysGroupMutation$data;
  variables: PersonBulkUpdateHolidaysGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "current_holidays_group_id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "new_holidays_group_id"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "holidaysGroupId",
            "variableName": "new_holidays_group_id"
          },
          {
            "kind": "Variable",
            "name": "peopleIds",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "PeopleHolidayGroupUpdateOutput",
    "kind": "LinkedField",
    "name": "updatePeopleHolidayGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "is_placeholder": {
                    "_eq": false
                  }
                }
              }
            ],
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "people",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "holidays_groups",
                "kind": "LinkedField",
                "name": "holidays_group",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "people(where:{\"is_placeholder\":{\"_eq\":false}})"
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "_eq",
                        "variableName": "current_holidays_group_id"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "id"
                  }
                ],
                "kind": "ObjectValue",
                "name": "where"
              }
            ],
            "concreteType": "holidays_groups",
            "kind": "LinkedField",
            "name": "holidays_groups",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "distinct_on",
                    "value": "id"
                  }
                ],
                "concreteType": "people_aggregate",
                "kind": "LinkedField",
                "name": "people_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "people_aggregate(distinct_on:\"id\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonBulkUpdateHolidaysGroupMutation",
    "selections": (v4/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PersonBulkUpdateHolidaysGroupMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "06713cea105bb59fc1295f8a10075009",
    "id": null,
    "metadata": {},
    "name": "PersonBulkUpdateHolidaysGroupMutation",
    "operationKind": "mutation",
    "text": "mutation PersonBulkUpdateHolidaysGroupMutation(\n  $id: [Int!]!\n  $current_holidays_group_id: Int\n  $new_holidays_group_id: Int\n) {\n  updatePeopleHolidayGroup(input: {peopleIds: $id, holidaysGroupId: $new_holidays_group_id}) {\n    account {\n      id\n      people(where: {is_placeholder: {_eq: false}}) {\n        id\n        holidays_group {\n          id\n        }\n      }\n      holidays_groups(where: {id: {_eq: $current_holidays_group_id}}) {\n        id\n        people_aggregate(distinct_on: id) {\n          aggregate {\n            count\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d252c0aa77213a24637784f3120e987";

export default node;
